// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header__right[data-v-8b2388c2]{font-size:14px}", ""]);
// Exports
module.exports = exports;
